import React from 'react'
import {FaFacebook,FaInstagram} from 'react-icons/fa'
import {AiFillTwitterCircle} from 'react-icons/ai'

const Footer = () => {
    return (
        <div className="flex  items-center justify-center h-auto w-full mt-4 bg-gray-light ">
        <div className="flex flex-col items-center  lg:w-8/12   justify-center h-auto w-full lg:mt-20 ">
            <h1 className="font-poppins font-bold text-large" >
            NEWSLETTER SIGNUP
            </h1>
            {/* mail form div */}
            <div className="flex items-center justify-center mt-4 w-10/12">
            <input type="text" className="w-full flex-grow px-4 py-3 bg-white focus:outline-none focus:border-none" placeholder="Enter your email" />
            <button className="bg-tradr-green text-white font-meduim py-3 px-3  ">
            Sign Up
            </button>

            </div>
            {/* End of mail form div */}
            <p className=" hidden lg:flex text-tiny font-medium mt-4">
            Sign up for our newsletter and be the first who know of our special offers!
            </p>
            <p className="mt-4">
                follow us on 
            </p>
            <div className="flex items-center justify-center mt-4">
            <FaFacebook className="text-black mr-4" />
            <FaInstagram className="text-black mr-4" />
            <AiFillTwitterCircle className="text-black mr-4" />
            </div>
            <p className="text-tiny font-medium mt-4">
                @2022 Tradr. All rights reserved.
                </p>
            </div>

        </div>
    )
}

export default Footer
